import { Checkbox, FormControlLabel, Grid2 as Grid, Typography } from "@mui/material";
import { CheckSquare, Square } from "@phosphor-icons/react";
import React, { Fragment } from "react";
import { PROFESSIONS } from "../../../../enums/profileSetupEnums";
import { addRemoveArray } from "../../../../helpers/arrayHelper";

export const ProfessionsFilter = ({ professionsSelected, setProfessionsSelected }) => {

  const handleSelectProfession = (key, isAdd = true) => {
    setProfessionsSelected((prev) => addRemoveArray(prev, isAdd, key));
  };

  return (
    <Fragment>
      <Typography variant="subtitle1" fontWeight={700}>Professions</Typography>
      <Grid container>
        {
          Object?.values(PROFESSIONS)?.map((profession, index) => {
            const isSelected = professionsSelected?.includes(profession);
            return (
              <Grid key={`platform-key-${index}`} item size={{ xs: 12, sm: 3 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isSelected}
                      icon={<Square size={24} color="#919EAB" />}
                      checkedIcon={<CheckSquare size={24} weight="fill" />}
                    onChange={(event) => handleSelectProfession(profession, event.target.checked)}
                    />
                  }
                  label={profession}
                />
              </Grid>
            );
          })
        }
      </Grid>
    </Fragment>
  );
};